import React from "react";
import FilterFigure from "./filterFigure.jsx";

// Airline filter with INVERTED default: when no URL param is present every airline is treated as
// selected (the customer sees them all ticked and no filter is sent). Unticking narrows to the
// remaining carriers, stored as a "-"-joined carrier-id list in the `airlines` param. Ticking back
// to the full set clears the param again, so an untouched filter never appears in the URL and never
// hides offers. The option list comes from a carrier-unfiltered facet call, so unticked airlines
// always stay visible and re-selectable.
const FilterAirlines = ({ model, events }) => {
    const allKeys = model.options.map((o) => o.key.toString());
    const committed = events.getValues(model.key); // checked carrier ids, [] when the param is absent
    const hasFilter = committed.length > 0;

    const isChecked = (key) => !hasFilter || committed.includes(key.toString());

    const toggle = (key) => {
        const k = key.toString();
        const current = hasFilter ? allKeys.filter((x) => committed.includes(x)) : [...allKeys];
        const next = current.includes(k) ? current.filter((x) => x !== k) : [...current, k];

        if (next.length === 0) return; // keep at least one airline selected
        if (next.length >= allKeys.length) events.clearValue(model.key); // all ticked → no filter
        else events.setValues(model.key, next);
    };

    return model.options.map((option, idx) => {
        const inputId = `filter-airlines-${option.key}`;
        const selected = isChecked(option.key);
        return (
            <div key={option.key} className="filter-row">
                <div className="flex h-5 shrink-0 items-center">
                    <div className="group grid size-4 grid-cols-1">
                        <input
                            onChange={() => toggle(option.key)}
                            checked={selected}
                            id={inputId}
                            type="checkbox"
                            className="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 forced-colors:appearance-auto"
                        />
                        <svg
                            fill="none"
                            viewBox="0 0 14 14"
                            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white"
                        >
                            <path
                                d="M3 8L6 11L11 3.5"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="opacity-0 group-has-checked:opacity-100"
                            />
                        </svg>
                    </div>
                </div>
                <label htmlFor={inputId} className="filter-row__label">
                    {option.name}
                </label>
                <FilterFigure option={option} />
            </div>
        );
    });
};

export default FilterAirlines;
